export const GET_EMPLOYERS = 'app/get_employers'
export const GET_EMPLOYER_BY_ID = 'app/get_employer_by_id'
export const ADD_EMPLOYER = 'app/add_employer'
